import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

export interface ErrorReportingDialogData {
  message?: string;
  descriptionRequired?: boolean;
}

export interface ErrorReportingDialogResult {
  description: string;
}

@Component({
  selector: 'app-error-reporting-dialog',
  templateUrl: './error-reporting-dialog.component.html',
  styleUrls: ['./error-reporting-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorReportingDialogComponent implements AfterViewInit {
  @ViewChild('descriptionTextArea')
  private descriptionTextarea: ElementRef<HTMLTextAreaElement>;

  public description: string;

  get descriptionRequired() {
    return this.data.descriptionRequired ?? true;
  }

  get message() {
    return this.data.message ?? `Please enter any details that you think
would be helpful to troubleshoot this issue.  E.g., what were you
trying do?  In what way did the system behave in an unwanted manner?`;
  }

  get result(): ErrorReportingDialogResult {
    return {
      description: this.description,
    };
  }

  constructor(@Inject(MAT_DIALOG_DATA) private data: ErrorReportingDialogData) {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.descriptionTextarea.nativeElement.focus();
    }, 50);
  }
}
